import React from 'react';

import {
  CircleOutlined,
  GpsFixedOutlined,
  HorizontalRuleOutlined,
  MouseOutlined,
  RectangleOutlined,
  Tune,
} from '@mui/icons-material';
import ButtonPopover from './ButtonPopover';
import { List, ListItemText, ListItemIcon, ListItemButton } from '@common-ui/ui';

export default function UserdefinedMarkers({ onClick = null }) {
  const handleMarkerClick = (nextTool) => {
    onClick?.(nextTool);
  };

  const customMarkers = [
    {
      id: 'marker-cursor',
      value: null,
      label: 'Cursor',
      Icon: (props) => <MouseOutlined {...props} />,
      disabled: false,
    },
    {
      id: 'marker-point',
      value: 'Circle',
      label: 'Point',
      Icon: (props) => <GpsFixedOutlined {...props} />,
      disabled: false,
    },
    {
      id: 'marker-line',
      value: 'Line',
      label: 'Line',
      Icon: (props) => <HorizontalRuleOutlined {...props} />,
      disabled: false,
    },
    {
      id: 'marker-box',
      value: 'Rect',
      label: 'Box',
      Icon: (props) => <RectangleOutlined {...props} />,
      disabled: false,
    },
    {
      id: 'marker-Ellipse',
      value: 'Ellipse',
      label: 'Ellipse',
      Icon: (props) => <CircleOutlined {...props} />,
      disabled: false,
    },
  ];

  return (
    <ButtonPopover label="Custom" tooltip={'Custom Markers'} Icon={<Tune />}>
      <List dense>
        {customMarkers.map(({ id, value, label, Icon }) => (
          <ListItemButton
            sx={styles.button}
            key={`marker-tool-${id}`}
            onClick={() => handleMarkerClick(value)}
          >
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText primary={label} />
          </ListItemButton>
        ))}
      </List>
    </ButtonPopover>
  );
}

const styles = {
  button: { '&:hover': { backgroundColor: 'primary.main', '> *': { color: 'black' } } },
};
